export enum CustomComponentTypes {
  TEXT_INPUT = 'TEXT_INPUT',
  AMOUNT_INPUT = 'AMOUNT_INPUT',
  TEXT_BLOCK = 'TEXT_BLOCK',
  DROPDOWN = 'DROPDOWN',
  CHECKBOX = 'CHECKBOX',
  PENSION_SLIDERS = 'PENSION_SLIDERS',
  FILE_UPLOAD = 'FILE_UPLOAD',
  BUY_SELL_HOLIDAY = 'BUY_SELL_HOLIDAY',
  DATE_INPUT = 'DATE_INPUT',
  MULTI_SELECT = 'MULTI_SELECT',
  CONTACTS = 'CONTACTS',
  BENEFICIARIES = 'BENEFICIARIES',
  MULTI_SELECT_WITH_SUBFORM = 'MULTI_SELECT_WITH_SUBFORM',
  SLIDER = 'SLIDER',
  CALCULATED_VALUE = 'CALCULATED_VALUE',
  DOCUMENT_SIGNING = 'DOCUMENT_SIGNING',
}
